import React from "react"
import { twMerge } from "tailwind-merge"
import Typography from "aldoo-ra/Typography"

/**
 * PageHeader - shared title bar for Admin pages.
 *
 * Layout: title (+ optional subtitle) on the left, an optional search field
 * and an optional actions slot on the right. `search` and `actions` accept
 * whatever the page needs (buttons, a status chip, a dropdown, a mix of
 * those) - PageHeader only owns the title styling and the row layout.
 */
const PageHeader = ({
  title,
  subtitle,
  search,
  actions,
  className = "",
  children,
}) => {
  return (
    <div
      className={twMerge(
        "w-full flex items-center justify-between bg-admin_paper border-b border-admin_bordered p-4",
        className
      )}
    >
      <div>
        <Typography component="h1" variant="admin_h3">
          {title}
        </Typography>

        {subtitle && (
          <Typography variant="admin_body1_dim" className="my-0">
            {subtitle}
          </Typography>
        )}

        {children}
      </div>

      {(search || actions) && (
        <div className="flex items-center gap-2 flex-shrink-0">
          {search}
          {actions}
        </div>
      )}
    </div>
  )
}

export default PageHeader
